<template>
  <div>
    <!-- 装箱信息 -->
    <el-dialog :title="$t('message.packingInformation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1708px" center>
      <div class="content">
        <!-- 当前箱号 -->
        <div class="boxNum">
          {{ $t("message.presentBoxNum") }}:{{ boxDetail.number }} {{ boxDetail.origin_shelf_display }}
        </div>
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 数量 -->
            <li>
              {{ $t("message.number") }}
            </li>
           
            <!-- 商品费用 -->
            <li>{{ $t("message.forGoods") }}</li>
            <!--本箱装货数  -->
            <li class="flex2">{{ $t("message.quantityOfCargoInThisCase") }}</li>
             <!-- 库位 -->
             <li >{{ $t("message.location") }}</li>
            <!-- 其他箱已装箱数 -->
            <li>{{ $t("message.numberOfOtherBoxesPacked") }}</li>
            <!--取出到具体交易号数量  -->
            <li class="flex2" v-if="status == 21">
              {{ $t("message.takeItOutToASpecificTransactionNumber") }}
            </li>
          </ol>
          <!-- 订单详情 -->
          <div class="proder" v-for="(proder, proderIndex) in boxDetail.list" :key="proderIndex">
            <!-- 配送单号 -->
            <div class="head">{{ proder.porder_sn }}</div>
            <ul v-for="(item, index) in proder.list" :key="index">
              <!--   番号-->
              <li class="flex05">
                {{ item.sorting }}
              </li>
              <!-- 订单号 -->
              <li class="flex15">
                <div>
                  <p>{{ item.order_sn }}</p>
                  <p>{{ item.realname }}</p>
                </div>
              </li>
              <!--照片-->
              <li>
                <div>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                        <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                      </a>
                    </el-popover>
                  </div>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 数量 -->
              <li>
                <div>
                  <!-- 提出数 -->
                  <p>{{ $t("message.putForwardNum") }}：{{ item.submitNum }}</p>
                  <!-- 待装箱 -->
                  <p>
                    {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
                  </p>
                  <!-- 已装箱 -->
                  <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
                  <!-- 已出货 -->
                  <!-- <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p> -->
                </div>
              </li>
              
              <!-- 价格.元 -->
              <li>
                <div>
                  <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                  <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
                </div>
              </li>

              <!--本箱装货数  -->
              <li class="flex2">
                <div class="template">
                  <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                    <span>
                      JY{{ purchaseIndex + 1 }}:
                      <a href="javascript:;" style="color: #fa5058">
                        {{ purchase.order_purchase.purchase_no }}
                      </a>
                    </span>
                    <!-- 装箱数 -->
                    <span>{{ $t("message.packingNumber") }}:{{purchase.num}}</span>
                  </div>
                </div>
              </li>
              <!-- 库位 -->
              <li >
                <div class="template">
                  <p v-for="(grid, gridIndex) in item.from_grids" :key="gridIndex">
                    {{ formatFromGrid(grid) }}
                  </p>
                </div>
              </li>
              <!-- 其他箱已装箱数 -->
              <li>
                {{ item.other_freight_num }}
              </li>
              <!--取出到具体交易号数量  -->
              <li class="flex2" v-if="status == 21">
                <div class="template">
                  <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                    <span>
                      JY{{ purchaseIndex + 1 }}:
                      <a href="javascript:;" style="color: #fa5058">
                        {{ purchase.order_purchase.purchase_no }}
                      </a>
                    </span>
                    <!-- 取消装箱数 -->
                    <span>
                      <el-input v-model="purchase.cancelEncasementNum" onfocus="this.select()"
                        @input="maxNum(proderIndex, index, purchaseIndex)"
                        onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" size="small"></el-input>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <ul>
              <!--   番号-->
              <li class="flex05">
                合计： <span style="color: #fa5058;font-size: 18px;font-weight: bold;">{{ proder.list.length }}</span> 番
              </li>
              <!-- 订单号 -->
              <li class="flex15">

              </li>
              <!--照片-->
              <li>

              </li>
              <!-- 商品属性 -->
              <li class="flex15">

              </li>
              <!-- 数量 -->
              <li>

              </li>
              <!-- 库位 -->
              <li class="flex15">

              </li>
              <!-- 价格.元 -->
              <li>

              </li>
              <!--本箱装货数  -->
              <li class="flex2">
                <div class="template">
                  <p style="text-align: right;">
                    总装箱数： <span style="color: #fa5058;font-size: 18px;font-weight: bold;">{{ packingNum }}</span>
                  </p>
                </div>
              </li>
              <!-- 其他箱已装箱数 -->
              <li>

              </li>
              <!--取出到具体交易号数量  -->
              <li class="flex2" v-if="status == 21">

              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 箱子列表 -->
      <div class="box" v-if="boxStatus == '装箱中'">
        <div class="box-title">
          {{ $t("message.theCurrentOrderIsInBox") }}
        </div>
        <!-- 箱子 -->
        <div v-for="(item, index) in filtrateBoxList" :key="index">
          <!-- 配送单分箱子 -->
          <h6>
            <span v-if="item.is_current">【当前配送单】</span>
            {{ item.is_main ? "并单主单号" : "并单子单号" }} ：{{ item.porder_sn }}
          </h6>
          <!-- 箱子组合 -->
          <div v-for="(items, indexs) in item.group" :key="indexs">
            <!-- 箱子列表 -->
            <div class="box-list">
              <div class="item" v-for="(box, boxs) in items.list" :key="boxs">
                <div class="item-box">
                  <el-radio v-model="id" :label="box.id"> </el-radio>
                  <div class="item-content">
                    <div class="remark">
                      <p class="text-one">
                        NO{{ boxs + 1 }}： {{ $t("message.actualWeight") }}:{{ box.weight }}kg
                      </p>
                    </div>
                    <div class="NO">
                      {{ box.length }}*{{ box.width }}*{{ box.height }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 确认移箱 -->
        <el-button type="primary" @click="moveOut" v-if="boxStatus == '装箱中' && isAuth(248)">
          {{ $t("message.confirmationOfBoxMoving") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getAreaGridName } from '@/utlis/warehouseGrid'
export default {
  data() {
    return {
      dialogVisible: false,
      porder_sn: this.$route.query.porder_sn,
      id: "",

    };
  },
  computed: {
    ...mapState({
      boxDetail: (state) => state.porderDetail.boxDetail,
      boxList: (state) => state.porderDetail.boxList,
      boxStatus: (state) => state.porderDetail.boxStatus,
      status: (state) => state.porderDetail.status,
    }),
    packingNum() {
      let num = 0
      console.log(this.boxDetail);
      this.boxDetail.list.forEach(item => {
        item.list.forEach(items => {
          items.list.forEach(detail => {
            num += detail.num - 0
          })
        })
      })
      return num
    },
    //筛选出待装箱的箱子列表
    filtrateBoxList() {

      let list = JSON.parse(JSON.stringify(this.boxList));
      list.forEach((item) => {
        item.group = item.group.filter((items) => items.statusName == "装箱中");

      });
      return list;
    },
  },
  created() { },
  methods: {
    // 装箱信息与配送单列表统一展示“区域用途编码-库位编号 数量个”。
    formatFromGrid(grid) {
      return `${getAreaGridName(grid.area_type_code, grid.grid_number)} ${grid.num}个`
    },
    // 移箱
    moveOut() {
      let datas = {
        freight_id_old: this.boxDetail.freight_id,
        freight_id_new: this.id,
        list: [],
      };
      //   移箱数据
      this.boxDetail.list.forEach((porder) => {
        porder.list.forEach((item) => {
          item.list.forEach((items) => {
            if (items.cancelEncasementNum > 0) {
              datas.list.push({
                porder_sn: porder.porder_sn,
                order_purchase_id: items.order_purchase_id,
                num_move: items.cancelEncasementNum,
              });
            }
          });
        });
      });
      this.$api.porderApi.moveFreightGoods(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("freightList", {
          porder_sn: this.porder_sn,
        });
        this.$store.commit("setBoxIds", []);
      });
    },
    //装箱数最大数
    maxNum(proderIndex, index, purchaseIndex) {
      let item =
        this.boxDetail.list[proderIndex].list[index].list[purchaseIndex];
      if (item.cancelEncasementNum > item.num) {
        item.cancelEncasementNum = item.num;
        this.$message.error("移箱数量不能大于本箱装货数");
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .table {
    .head {
      line-height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #dedede;
    }

    .proder {
      max-height: 600px;
      overflow-y: auto;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .box-title {
    text-align: center;
    margin: 48px 0 24px;
    font-size: 18px;
  }

  h6 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 8px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
